import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUp, Clock, Users, Shield, Truck, BarChart3, Package, Globe } from 'lucide-react';

const VendorsAdvantages: React.FC = () => {
  const advantages = [
    { icon: TrendingUp, title: "Low Service Fees", desc: "Industry-leading rates" },
    { icon: Clock, title: "Quick Onboarding", desc: "Start in 24 hours" },
    { icon: Users, title: "Large Customer Base", desc: "2M+ active users" },
    { icon: Shield, title: "Secure Payments", desc: "Guaranteed security" },
    { icon: Truck, title: "Smart Delivery System", desc: "10-minute network" },
    { icon: BarChart3, title: "Analytics", desc: "Real-time insights" },
    { icon: Package, title: "Inventory", desc: "Smart tracking" },
    { icon: Globe, title: "Marketing", desc: "Low Cost campaigns" }
  ];

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Advantages <span className="bg-gradient-to-r from-red-500 to-orange-500 bg-clip-text text-transparent">Onboarding</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {advantages.slice(0, 4).map((advantage, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-red-200 hover:shadow-lg transition-all duration-300 group text-center"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              <div className="w-16 h-16 bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                <advantage.icon className="w-8 h-8 text-red-500" />
              </div>
              <h3 className="font-bold text-gray-800 mb-2">{advantage.title}</h3>
              <p className="text-sm text-gray-600">{advantage.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center">
          <div className="lg:col-span-2">
            <div className="grid md:grid-cols-2 gap-6">
              {advantages.slice(4, 8).map((advantage, index) => (
                <motion.div
                  key={index + 4}
                  className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-red-200 hover:shadow-lg transition-all duration-300 group text-center"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  whileHover={{ y: -5 }}
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-red-50 to-orange-50 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                    <advantage.icon className="w-8 h-8 text-red-500" />
                  </div>
                  <h3 className="font-bold text-gray-800 mb-2">{advantage.title}</h3>
                  <p className="text-sm text-gray-600">{advantage.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>

          <motion.div 
            className="flex justify-center"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            viewport={{ once: true }}
          >
            <div className="w-64 h-[520px] bg-gray-900 rounded-[3rem] p-3 shadow-2xl">
              <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden relative">
                <div className="bg-gradient-to-br from-red-500 via-red-600 to-orange-500 p-6 text-white text-center">
                  <div className="text-xl font-bold mb-2">Vendor App</div>
                  <div className="text-sm opacity-90">Manage Everything</div>
                </div>
                
                <div className="p-6 space-y-4">
                  <div className="bg-green-50 rounded-xl p-4">
                    <div className="text-green-600 font-semibold text-sm">Today's Sales</div>
                    <div className="text-xl font-bold text-green-700">₹15,420</div>
                  </div>
                  
                  <div className="bg-blue-50 rounded-xl p-4">
                    <div className="text-blue-600 font-semibold text-sm">Active Orders</div>
                    <div className="text-xl font-bold text-blue-700">47</div>
                  </div>
                  
                  <div className="bg-orange-50 rounded-xl p-4">
                    <div className="text-orange-600 font-semibold text-sm">Rating</div>
                    <div className="text-xl font-bold text-orange-700">4.8★</div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default VendorsAdvantages; 